import React from 'react'
import './AllMapProjects.scss'
import PropTypes from 'prop-types'
import { MapProjectCardItem } from '@components/custom'

const AllMapProjects = props => {
    const { mapProjects, totalMapsCount } = props

    return (
        <div data-testid="all-projects">
            {
                (totalMapsCount > 0) ? (
                    <div data-testid="all-projects-data">
                        <div className="all-projects-menu">
                            <div className="all-projects-title">{totalMapsCount} Map Projects</div>
                        </div>
                        <div>
                            {mapProjects && mapProjects.map((project, index) =>
                                <MapProjectCardItem key={index} index={index} property={project} />
                            )}
                        </div>
                    </div>
                ) : (
                    <div data-testid="no-projects-data" className="no-projects">No Map Projects Found</div>
                )
            }
        </div>
    )
}

AllMapProjects.propTypes = {
    mapProjects: PropTypes.array,
    totalMapsCount: PropTypes.number
}

export default AllMapProjects
